module.exports = __webpack_public_path__ + "img/d2ba884.jpg";